module.exports = __webpack_public_path__ + "media/images/iconbox/icon7-0a36f4de62c29fb698efe57414be54ea.png";